export default "/assets/images/decibels-graph-sm.1d570991b8f16ddb.svg";